import { createEntitySource } from 'serviceWorker/channelServers/entitySource';
import * as dbIssueWorkflows from 'serviceWorker/db/issueWorkflows/issueWorkflows';
import * as dbIssueWorkflowsService from 'serviceWorker/db/issueWorkflows/issueWorkflowsService';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { issueWorkflowsSync } from './index';

/**
 * Workflows of the selected project stored in IndexedDB. A read does not sync
 * them again: their pull has no sync key, so it downloads them anew and
 * broadcasts `clearData`, which makes the page read again, endlessly. Changes
 * of workflows and stages sync them through the HTTP queue.
 */
export const issueWorkflowSource = createEntitySource({
  service: dbIssueWorkflowsService,
  contract: workflowContract,
  ...issueWorkflowsSync,
  readAll: () => dbIssueWorkflows.get(),
  syncAfterRead: false,
});
